import { createElement } from 'react';
import type { DrawerPayload } from '@/features/project-board/components/DetailDrawer';
import { DataQueryFormat as Format } from '@/features/data-query/format';
import type { DataQueryExecution } from '@/features/data-query/types';

export class DataQueryDetail {
  static payload(execution: DataQueryExecution): DrawerPayload {
    const threadUrl = Format.threadUrl(execution.threadUrl);
    const thread = `${execution.channelId} / ${execution.threadTs}`;
    return {
      key: execution.executionId, kind: 'data-query', title: Format.label(execution.outcome),
      meta: [
        { label: '실행 ID', value: execution.executionId },
        { label: '요청자', value: Format.requester(execution) },
        { label: '채널 / 스레드', value: threadUrl ? createElement('a', { href: threadUrl, target: '_blank', rel: 'noopener noreferrer', className: 'text-accent underline' }, thread) : thread },
        { label: '결과', value: Format.label(execution.outcome) },
        { label: '행 수', value: Format.number(execution.rowCount) },
        { label: '시도 수', value: Format.number(execution.attemptCount) },
        { label: '파일 ID', value: execution.fileId ?? '—' },
        { label: '파일 이름', value: execution.fileName ?? '—' },
        { label: '시작 (KST)', value: Format.kst(execution.startedAt) },
        { label: '종료 (KST)', value: Format.kst(execution.finishedAt) },
        { label: '소요 시간', value: `${Format.number(execution.durationMs)}ms` },
      ],
      docs: [],
      body: {
        label: '요청 문장 · 적용 조건 · SQL',
        // 사용자 원문은 Markdown 파서를 거치지 않고 React 텍스트 노드로만 렌더한다.
        content: createElement('div', null,
          ...[
            { title: '요청 문장', text: execution.question },
            { title: '적용 조건', text: execution.conditions ?? '기록 없음' },
            { title: 'SQL', text: execution.finalSql ?? '기록 없음' },
          ].map(({ title, text }) => createElement('section', { key: title, className: 'mb-5' },
            createElement('h2', { className: 'mb-2 font-semibold text-ink' }, title),
            createElement('pre', { className: 'whitespace-pre-wrap break-words rounded border border-line-soft bg-canvas p-3 text-sm text-ink' }, text),
          )),
        ),
      },
    };
  }
}
